import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './styles.module.css';

import { SwitchTheme } from '../SwitchTheme';
import { ModalContactUs } from './components/ModalContactUs';

import avatar from '../../assets/images/avatar.png';
import * as routes from '../../constants/Routes';
import { useAuth } from '../../hooks/useAuth';
import { useTheme } from '../../hooks/useTheme';
import { toast } from 'react-toastify';
import { InstallPWA } from '../installPWA';
import { isSafari, isIOS } from 'react-device-detect';

export function NavigationBar() {
  const { client, player, notificationCount, notifications, signOut } =
    useAuth();

  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeRoute, setActiveRoute] = useState('');
  const [playerName, setPlayerName] = useState<string>();

  const [modalContactUsIsOpen, setModalContactUsIsOpen] =
    useState<boolean>(false);

  useEffect(() => {
    if (player) {
      const { name } = player;

      let playerNameAndLastname = name.trim();
      playerNameAndLastname = playerNameAndLastname.split(' ');
      playerNameAndLastname =
        playerNameAndLastname.length > 1
          ? `${playerNameAndLastname[0]} ${
              playerNameAndLastname[playerNameAndLastname.length - 1]
            }`
          : `${playerNameAndLastname[0]}`;
      setPlayerName(playerNameAndLastname);
    }
  }, []);

  useEffect(() => {
    const splitPathName = location.pathname.split('/');
    const pathName = splitPathName[1];

    setActiveRoute(pathName);

    // getNotifications();
  }, [location.pathname]);

  async function logOff() {
    signOut();

    navigate(`/_/${client.clientUrl}`);
  }

  const onHandlePage = (route: string) => {
    if (route === 'home') {
      // console.log('mandar pra home');
      navigate(`${routes.HOME}`);
    }
    if (route === 'redeemAwards') {
      // console.log('mandar pra RedeemAwards');
      navigate(`${routes.REDEEM_AWARDS}`);
    }
    if (route === 'results') {
      // console.log('mandar pra Results');
      navigate(`${routes.RESULTS}`);
    }
    if (route === 'notifications') {
      // console.log('mandar pra notifications');
      navigate(`${routes.NOTIFICATIONS}`);
    }
    if (route === 'profile') {
      // console.log('mandar pra MyProfile');
      navigate(`${routes.PROFILE}`);
    }
    if (route === 'infos') {
      // console.log('mandar pra Infos');
      navigate(`${routes.INFOS}`);
    }
  };

  const toggleModalContactUs = () => {
    setModalContactUsIsOpen(!modalContactUsIsOpen);
  };

  return (
    <>
      {client &&
        client.favIcon &&
        client.companyName &&
        client.primaryColor &&
        client.clientUrl &&
        !isSafari &&
        !isIOS &&
        player.email !== 'tester@oqdigital.com' && (
          <InstallPWA
            icon={client.favIcon}
            name={client.companyName}
            text={`Instale o app da ${client.companyName} em seu dispositivo!`}
            color={client.primaryColor}
            client={client.clientUrl}
          />
        )}
      <nav className={`${styles.navbarCustom} fixed-top`}>
        <div className="container d-flex">
          <div className={styles.contentLeft}>
            <img width={130} src={client && client.logoURL} alt="" />
          </div>
          <div className={styles.contentRight}>
            <ul className="d-none d-lg-flex">
              <li
                onClick={() => onHandlePage('home')}
                className={`${styles.clickable} ${
                  activeRoute === 'home' ? styles.active : ''
                } me-4`}
              >
                <i className={`material-icons-outlined me-2`}>home</i>
                <span>Início</span>
              </li>

              <li
                onClick={() => onHandlePage('redeemAwards')}
                className={`${styles.clickable} ${
                  activeRoute === 'redeemAwards' ? styles.active : ''
                } me-4`}
              >
                <i className="material-icons-outlined me-2">emoji_events</i>
                <span>Premiações</span>
              </li>

              <li
                onClick={() => onHandlePage('results')}
                className={`${styles.clickable} ${
                  activeRoute === 'results' ? styles.active : ''
                } me-4`}
              >
                <i className="material-icons-outlined me-2">people</i>
                <span>Resultados</span>
              </li>
              <li
                onClick={() => onHandlePage('notifications')}
                className={`${styles.clickable} ${
                  activeRoute === 'notifications' ? styles.active : ''
                } me-4`}
              >
                {notificationCount && Number(notificationCount) >= 9 ? (
                  <div className="position-relative">
                    <span className={styles.littleBall}>
                      {notifications.length}+
                    </span>
                  </div>
                ) : (
                  notificationCount &&
                  Number(notificationCount) > 0 &&
                  Number(notificationCount) < 9 && (
                    <div className="position-relative">
                      <span className={styles.littleBall}>
                        {notifications.length}
                      </span>
                    </div>
                  )
                )}
                <i className="material-icons-outlined me-2">notifications</i>
                <span>Notificações</span>
              </li>
            </ul>
          </div>
          <div className="dropdown d-flex">
            <button
              className="btn dropdown-toggle btn-sm"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className={`${styles.navbarText} me-3`}>{playerName}</span>
              <img
                width={40}
                src={player.photoURL ? player.photoURL : avatar}
                className={`${styles.userPic} me-2`}
                alt=""
              />
            </button>
            <ul className="dropdown-menu dropdown-menu-end">
              <li
                onClick={() => onHandlePage('profile')}
                className={`${styles.clickable} dropdown-item`}
              >
                <div className="d-flex align-items-center">
                  <i className="material-icons-outlined tiny me-3">person</i>
                  <span>Meu Perfil</span>
                </div>
              </li>
              <li
                onClick={() => onHandlePage('infos')}
                className={`${styles.clickable} dropdown-item`}
              >
                <div className="d-flex align-items-center">
                  <i className="material-icons-outlined tiny me-3">info</i>
                  <span>Tire dúvidas</span>
                </div>
              </li>

              {client.settings?.statement?.enabled && (
                <>
                  <li
                    onClick={() => navigate(routes.EXTRACT)}
                    className={`${styles.clickable} dropdown-item`}
                  >
                    <div className="d-flex align-items-center">
                      <i className="material-icons-outlined tiny me-3">
                        subject
                      </i>
                      <span>Extrato</span>
                    </div>
                  </li>
                </>
              )}

              <li
                onClick={() => toggleModalContactUs()}
                className={`${styles.clickable} dropdown-item`}
              >
                <div className="d-flex align-items-center">
                  <i className="material-icons-outlined tiny me-3">chat</i>
                  <span>Fale conosco</span>
                </div>
              </li>
              <li className={`${styles.clickable} dropdown-item`}>
                <div className="d-flex align-items-center">
                  <i className="material-icons-outlined tiny me-3">
                    {theme === 'light' ? 'light_mode' : 'dark_mode'}
                  </i>
                  <SwitchTheme />
                </div>
              </li>

              <li
                onClick={() => {
                  if (player.acceptedTerms && player.cpf) {
                    logOff();
                  } else {
                    if (client.loginEmail === 'false') {
                      toast.warn(
                        'Vimos que você não completou seus dados.Para continuar a usar esta conta, por favor complete seus dados.',
                        { autoClose: false }
                      );
                      navigate(routes.EDIT_PROFILE);
                    } else {
                      logOff();
                    }
                  }
                }}
                className={`${styles.clickable} dropdown-item`}
              >
                <div className="d-flex align-items-center">
                  <i className="material-icons-outlined tiny me-3">logout</i>
                  <span>Sair</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <ModalContactUs
        modalIsOpen={modalContactUsIsOpen}
        closeModal={toggleModalContactUs}
        client={client}
        player={player}
      />
    </>
  );
}
